import { Grid, Toolbar } from "@mui/material"
import React, { useContext, useMemo } from "react"
import { useLocation } from "react-router-dom"
import { customPalette, theme } from "../../../../theme"
import { AppSideBarContext } from "../../../core/context/AppSideBarContext/AppSideBarContext"
import { UrlStateEnum } from "../../../core/context/AppSideBarContext/UrlStateEnum"
import { AppNavBarContext } from "../../../core/context/nav-bar/AppNavBarContext"
import { BackButtonNavbar } from "../../buttons/back-button/BackButtonNavbar"
import { DefaultTypography } from "../../typography/default-typography"
import "../app-navbar-v2.scss"
import { StepHeader } from "./StepHeader"

export function StepHeaderNavbar(): React.JSX.Element {
  const { urlState } = useContext(AppSideBarContext)
  const { title } = useContext(AppNavBarContext)

  const location = useLocation()

  const steps = useMemo(() => {
    if (urlState === UrlStateEnum.PROJECTS) {
      if (location.pathname.endsWith("/import")) {
        return ["Importer la maquette", "Contrôler la maquette"]
      }
    } else if (urlState === UrlStateEnum.BEEM_PILOT) {
      return ["Importer le fichier RSEE", "Diagnostic de l'import"]
    }
    return []
  }, [location.pathname, urlState])

  return (
    <Toolbar
      sx={{
        color: customPalette.white,
        borderRadius: 5,
        backgroundColor: customPalette.dark1,
        ...theme.mixins.toolbar,
      }}>
      <Grid container alignItems="center">
        <Grid item xs={3} display="flex" alignItems="center">
          <BackButtonNavbar />

          <DefaultTypography label={title} fontWeight={600} color="white" />
        </Grid>

        <Grid item xs={6} display="flex" justifyContent="center" alignContent="center">
          <StepHeader steps={steps} />
        </Grid>
      </Grid>
    </Toolbar>
  )
}
